import { PopoverController } from '@ionic/angular';
import { StatusService } from './../../status.service';
import { LocalStorageService } from './../../local-storage.service';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit {
  @Input() testStatus: string;

  constructor(private statusService: StatusService, private popoverController: PopoverController) {

   }

  ngOnInit() {
    if(this.statusService.hasTestFinished()){
      this.testStatus='test_finished';
    }
    else if(this.statusService.hasTestStarted()){
      this.testStatus='test_started';
    }
    else{
      this.testStatus='test_not_started';
    }
  }

  async dismissClick() {
    await this.popoverController.dismiss();
      }

}
